/* eslint-disable max-len */
/* eslint-disable no-undef */
import React from "react";
import { showLoading } from 'react-global-loading';
export const userData = localStorage.getItem('persist:root') ?
  JSON.parse(JSON.parse(localStorage.getItem('persist:root')).userData) : '';
class GlobalCollab extends React.Component {
  constructor(props) {
    super(props);

  }

  componentDidMount = () => { window.scrollTo(0, 0); };

  render() {

    return (
      <div className="container">
        <h2 className="abthdn">Coming soon</h2>
      </div>
    );
  }
}
export default GlobalCollab;